import React from 'react';

const Footer = () => (
  <div className='footer'>
    <p>We have helped over 500 families so far!&emsp;Sign up and let us help you!&emsp;Or offer your help for a family in need!</p>
  </div>
);

export default Footer;